
import { APP_SETTINGS } from "../../../../config";
import { getFilteredQuery } from "app/assets/genericActions";
import api from '../axiosInstance'; 

const getAuthHeaders = (auth) => {
  if (!auth || !auth.token) {
    console.error("Auth object or token is missing for API request.");
    return {};
  }
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth.token}`,
    },
  };
};

export function login(loginData) {
  return api.post(APP_SETTINGS.API_PATH.USER.login, loginData);
}

export function logout() {
  return api.post(APP_SETTINGS.API_PATH.USER.logout);
}

export function createEmployee(employeeData, token) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`,
    },
  };
  return api.post(APP_SETTINGS.API_PATH.USER.createEmployee, employeeData, config);
}

export function getAllUsers(data, auth) {
  return api.get(
    `${APP_SETTINGS.API_PATH.USER.getAllUsers}?${getFilteredQuery(data)}`,
    getAuthHeaders(auth)
  );
}

export function getUser(id, auth) {
  return api.get(`${APP_SETTINGS.API_PATH.USER.getUser}/${id}`, getAuthHeaders(auth));
}

export function updateUser(userData, token) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`,
    },
  };
  return api.patch(APP_SETTINGS.API_PATH.USER.updateUser, userData, config);
}

export function removeUser(filter,userId, auth) {
  return api.delete(`${APP_SETTINGS.API_PATH.USER.remove}/${userId}?${getFilteredQuery(filter)}`, getAuthHeaders(auth));
}

export function restoreUser(userId, auth) {
  return api.patch(APP_SETTINGS.API_PATH.USER.restore.replace(':id',userId),{}, getAuthHeaders(auth));
}

export function changePassword(userData, auth) {
  return api.patch(APP_SETTINGS.API_PATH.USER.changePassword, userData, getAuthHeaders(auth));
}

export function forgotPassword(email) {
  return api.post(APP_SETTINGS.API_PATH.USER.forgetPassword, email);
}

export function resetPassword(otp, password) {
  return api.post(`${APP_SETTINGS.API_PATH.USER.resetPassword}/${otp}`, password);
}
export function getNotCheckedInUsers(auth) {
  return api.get(APP_SETTINGS.API_PATH.USER.getNotCheckedIn, getAuthHeaders(auth));
}
export const getUsersOnBreak = async (auth) => {
  return api.get(APP_SETTINGS.API_PATH.USER.getOnBreak, getAuthHeaders(auth));
};